import BoardsApi from './boardsApi'
import {DOMAIN_NAME, PREFIX} from './Constants'
import {ownRequest} from './ownFetch'


export function tokenRequest(data) {
  let auth = data ? BoardsApi.userPasswordEncode(data.identifier, data.password) : localStorage.getItem('auth');
  let header = new Headers({
    'Accept': 'application/vnd.uberblik.accessTokenRequest+json',
    'Authorization': auth,
    'Content-Type': 'application/json;charset=utf-8'
  });

  return fetch(DOMAIN_NAME + PREFIX + '/accesstokens', {
    mode: 'cors',
    method: 'POST',
    headers: header,
    body: '{"accessTokenRequest":{"clientId":"we2$%6etetertef","grantType":"password"}}'
  }).then(function (response) {
    return response
  });

}

export function deleteToken() {
  return ownRequest('DELETE', PREFIX + '/accesstokens')
}



// WEBPACK FOOTER //
// ./src/api/tokenRequest.js